import { post, get, patch } from "@/config/axios"

export const authService = {
    login: (formData: FormData) => post(`users/login`, formData),
    getMyProfile: () => get(`users/profile`),
    resetMyPassword: (formData: FormData) => patch(`users/password`, formData),
    logout:() => get("users/logout")
}
